<template>
  <div class="the-footer">
    ©2020 by MathTestNinja
  </div>
</template>

<script>
export default {
  name: 'TheFooter',
}
</script>

<style lang="scss" scoped>
.the-footer {
  margin: 100px auto;
  text-align: center;
}
</style>
